import React, { useEffect, useRef, useState } from "react";
import { updatePlayerAttribute } from "../firebase/fireFuncs";
import Checkmark from "../misc/elements/Checkmark";
import PickImageImage from "../misc/elements/PickImageImage";
import MainStore from "../stores/MainStore";

const PlayerName = ({ showVerifiyButtons, setShowVerifyButtons }) => {
  const { player, verifiedId } = MainStore();
  const [inputOpen, setInputOpen] = useState(false);
  const [newName, setNewName] = useState("");
  const checkmarkRef = useRef();

  function updateProfileImage(path) {
    updatePlayerAttribute(player.uid, "profileImage", path);
  }

  const handleChange = (e) => {
    const result = e.target.value.replace(/[^a-z]/gi, "");
    setNewName(result);
  };

  function changePlayerName() {
    if (newName.length > 3) {
      updatePlayerAttribute(player.uid, "name", newName);
      setInputOpen(false);
      setNewName("");
    }
  }

  function clickPlayerName() {
    if (player.name == "New Player") {
      setInputOpen(true);
    }
  }

  function onEnter(e) {
    if (e.key == "Enter") checkmarkRef.active.click();
  }

  return (
    <div
      className="divColumn"
      style={{ width: "100%", justifyContent: "baseline", marginRight: "10px" }}
    >
      <PickImageImage
        imageWidth={"50%"}
        size="60%"
        imgUrl={player?.profileImage}
        standardImage={"/icons/icon_player.png"}
        storagePath={`/profiles/${player?.uid}`}
        onImageChanged={updateProfileImage}
      />
      <button
        className="divColumn"
        style={{
          backgroundColor: "#2f2f2f",
          width: "100%",
          justifyContent: "center",
          backgroundColor: "#2f2f2f",
          position: "relative",
        }}
      >
        {!inputOpen && (
          <div
            className="textBoldWhite"
            style={{ fontSize: "20px" }}
            onClick={clickPlayerName}
          >
            {player?.name ?? "Not Playing"}
          </div>
        )}
        {inputOpen && (
          <div className="divRow">
            <input
              onKeyDown={onEnter}
              value={newName}
              onChange={handleChange}
              style={{
                zIndex: 1000000,
                textAlign: "center",
                height: "100%",
                backgroundColor: "#2f2f2f",
                color: "white",
                width: "100%",
                fontSize: "20px",
              }}
            />
            {newName.length > 3 && (
              <Checkmark
                checkmarkRef={checkmarkRef}
                divWidth={"20px"}
                size={"20px"}
                onChecked={changePlayerName}
              />
            )}
          </div>
        )}
        {!showVerifiyButtons && !verifiedId && (
          <div
            style={{ position: "fixed", right: 0, marginRight: "20px" }}
            onClick={() => {
              setShowVerifyButtons(true);
            }}
          >
            <div style={{ color: "lightblue", textDecoration: "underline" }}>
              verify
            </div>
          </div>
        )}
      </button>
    </div>
  );
};

export default PlayerName;
